module.exports = __webpack_public_path__ + "static/travelworld_logo-0c3c5627f75e62370fc3187338b5b4db.png";